import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class WatercraftTypeService extends BaseCollectionService {
  constructor() {
    super("watercraftTypes");
  }

  async getWatercraftTypes(query?: Record<string, any>) {
    const path = `watercraftTypes`;
    return await this.request(
      {
        method: "get",
        url: path,
        params: query
      },
      { useToken: "access" }
    );
  }

  public async deleteBulkWatercraftTypes(_ids: string[]) {
    const path = `watercraftTypes-bulk`;
    return await this.request(
      {
        method: "delete",
        url: path,
        data: { _ids }
      },
      { useToken: "access" }
    );
  }

  async deleteBulk(watercraftTypeIds: string[]): Promise<ResponseWrapper> {
    const path = `watercraftTypes/bulk-delete`;
    return await this.request(
      { method: "put", url: path, data: { watercraftTypeIds } },
      { useToken: "access" }
    );
  }

  async restoreBulk(watercraftTypeIds: string[]): Promise<ResponseWrapper> {
    const path = `watercraftTypes/bulk-restore`;
    return await this.request(
      { method: "put", url: path, data: { watercraftTypeIds } },
      { useToken: "access" }
    );
  }
}

export default new WatercraftTypeService();
